import Cookies from "js-cookie";

const BASE_URL = process.env.NEXT_PUBLIC_BASE_URL;

export const createNotification = async (formData: FormData) => {
  try {
    const response = await fetch(`${BASE_URL}/notification`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${Cookies.get("accessToken") || ""}`,
      },
      body: formData,
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data?.message || "Failed to create notification");
    }

    return data;
  } catch (error) {
    console.error("Create notification error:", error);
    throw error;
  }
};

export const getNotification = async () => {
  try {
    const res = await fetch(`${BASE_URL}/notification`, {
      method: "GET",
      cache: "no-store",
    });
    const data = await res.json();
    if (!res.ok) {
      throw new Error(data?.message || "Failed to create notification");
    }

    return data;
  } catch (error) {
    console.log(error);
  }
};

export const getActiveNotifications = async () => {
  try {
    const response = await fetch(`${BASE_URL}/notification?status=active`, {
      method: "GET",
      cache: "no-store",
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data?.message || "Failed to fetch notifications");
    }

    return data;
  } catch (error) {
    console.error("Get notifications error:", error);
    throw error;
  }
};

export const getNotificationsByAuthorityId = async (authorityId: string) => {
  try {
    const response = await fetch(
      `${BASE_URL}/notification/authority/${authorityId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.message || "Failed to fetch notifications");
    }

    return result;
  } catch (error) {
    console.error("getNotificationsByAuthorityId error:", error);

    throw error;
  }
};

export interface IPushSubscription {
  _id?: string;
  userId?: string;
  endpoint: string;
  keys?: {
    p256dh: string;
    auth: string;
  };
  isActive: boolean;
  createdAt?: Date;
  updatedAt?: Date;
}

export const subscribePushNotification = async (
  subscription: PushSubscription,
  userId?: string,
) => {
  try {
    const response = await fetch(`${BASE_URL}/notification/subscribe`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        subscription,
        userId,
      }),
    });

    const data = await response.json();
    return data;
  } catch (error) {
    console.log("subscribe Push Notification", error);
  }
};

export const unsubscribePushNotification = async (endpoint: string) => {
  try {
    const response = await fetch(`${BASE_URL}/notification/unsubscribe`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        endpoint,
      }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Failed to unsubscribe");
    }

    return data;
  } catch (error) {
    console.error("Unsubscribe push notification error:", error);
    throw error;
  }
};

export interface IFCMSubscription {
  _id?: string;
  userId?: string | null;
  token: string;
  deviceType: "web" | "android" | "ios";
  browser?: string;
  isActive?: boolean;
  lastUsedAt?: Date;
  createdAt?: Date;
  updatedAt?: Date;
}

export const subscribeFCMToken = async (
  token: string,
  userId?: string,
  browser: string = "Chrome",
) => {
  try {
    const response = await fetch(`${BASE_URL}/notification/subscribe`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        token,
        userId: userId || null,
        deviceType: "web",
        browser,
      }),
    });

    const data = await response.json();

    if (!response.ok) {
      console.error("FCM subscribe failed:", data);

      return {
        success: false,
        ...data,
      };
    }

    console.log("FCM token subscribed successfully:", data);

    return data;
  } catch (error) {
    console.error("subscribe FCM token error:", error);

    return {
      success: false,
      message: "Failed to subscribe FCM token",
    };
  }
};

export const unsubscribeFCMToken = async (token: string) => {
  try {
    const response = await fetch(`${BASE_URL}/notification/subscribe`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        token,
      }),
    });

    const data = await response.json();

    if (!response.ok) {
      console.error("FCM unsubscribe failed:", data);

      return {
        success: false,
        ...data,
      };
    }
    return data;
  } catch (error) {
    console.error("unsubscribe FCM token error:", error);

    return {
      success: false,
      message: "Failed to unsubscribe FCM token",
    };
  }
};

export const deleteNotificationById = async (id: string) => {
  try {
    const res = await fetch(`${BASE_URL}/notification/${id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await res.json();
    return data;
  } catch (error) {
    console.log("delete notification by id failed");
  }
};
